<script>
import Skeleton from "@/shared/ui/custom/skeleton/Skeleton.vue";
import NotarialTransactionList from "@/pages/admin/notarial_transactions/NotarialTransactionList.vue";
import HereditaryCaseList from "@/pages/admin/hereditary_cases/HereditaryCaseList.vue";
import QuickActions from "@/features/quick-actions/ui/QuickActions.vue";
import CreateAction from "@/features/create-action/ui/CreateAction.vue";
import ClientsInOffice from "@/features/clients/ui/ClientsInOffice.vue";

import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "HomeView",
  components: {
    CreateAction,
    Skeleton,
    NotarialTransactionList,
    HereditaryCaseList,
    QuickActions,
    ClientsInOffice,
    Button,
  },
  data() {
    return {
      showCreateNotarial: false,
      activeTab: "",
      list: [],
    };
  },
  computed: {
    isNotary() {
      return this.$store.state.self_user?.role === "NOTARY";
    },
    canViewActions() {
      return this.$store.getters.has_access("TVNT");
    },
    canViewHereditary() {
      return this.$store.getters.has_access("IVND");
    },
    canCreateAction() {
      return this.$store.getters.has_access("TCNT");
    },
    canCreateHereditary() {
      return this.$store.getters.has_access("ICND");
    },
    showCreateButton() {
      if (this.activeTab === "actions") return this.canCreateAction;
      if (this.activeTab === "hereditary") return this.canCreateHereditary;
      return false;
    },
  },
  mounted() {
    if (this.canViewActions) {
      this.activeTab = "actions";
    } else if (this.canViewHereditary) {
      this.activeTab = "hereditary";
    }
  },
};
</script>

<template>
  <div class="content">
    <div class="body">
      <div v-if="isNotary" class="table">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <div class="text-foreground text-lg font-semibold">
              {{ $t("В процессе") }}
            </div>
            <div class="home-tabs">
              <button
                v-if="canViewActions"
                class="home-tab"
                :class="{ 'home-tab--active': activeTab === 'actions' }"
                @click="activeTab = 'actions'"
              >
                {{ $t("Действия") }}
              </button>
              <button
                v-if="canViewHereditary"
                class="home-tab"
                :class="{ 'home-tab--active': activeTab === 'hereditary' }"
                @click="activeTab = 'hereditary'"
              >
                {{ $t("Насл. дела") }}
              </button>
            </div>
          </div>
          <Button
            v-if="showCreateButton"
            variant="default"
            size="default"
            @click="showCreateNotarial = true"
          >
            {{ $t("Действие") }} +
          </Button>
        </div>

        <NotarialTransactionList v-if="activeTab === 'actions'" />
        <HereditaryCaseList v-if="activeTab === 'hereditary'" />
      </div>

      <QuickActions />
    </div>
    <ClientsInOffice v-if="isNotary" />

    <CreateAction
      v-if="isNotary && showCreateNotarial && activeTab === 'actions'"
      key="notarial-action"
      @close="showCreateNotarial = false"
    />
    <CreateAction
      v-if="isNotary && showCreateNotarial && activeTab === 'hereditary'"
      key="hereditary-case"
      :title="$t('Открыть наследственное дело')"
      :predefined-categories="['SVID_PRAVO_NASLED']"
      route-name="hereditary_case_new"
      @close="showCreateNotarial = false"
    />

    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
.content {
  @apply w-full h-full flex flex-col gap-5;

  .body {
    @apply flex flex-col gap-5 w-full;

    @media (min-width: 1400px) {
      @apply flex-1 flex-row min-h-0;
    }

    .table {
      @apply flex flex-1 flex-col overflow-auto bg-card gap-8 min-h-[400px];

      @media (min-width: 1400px) {
        @apply min-h-0;
      }
    }
  }
}

.home-tabs {
  @apply rounded-md;
  display: flex;
  align-items: center;
  border: 1px solid hsl(var(--border));
  overflow: hidden;

  .home-tab {
    padding: 6px 16px;
    font-size: 14px;
    font-weight: 400;
    color: hsl(var(--foreground));
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;

    &:not(:last-child) {
      border-right: 1px solid hsl(var(--border));
    }

    &:hover {
      background: hsl(var(--accent));
    }

    &--active {
      background: hsl(var(--muted));
      font-weight: 500;
    }
  }
}
</style>
